module.exports = __webpack_public_path__ + "media/site/images/products/avisboard-flat-screen3@2x-b76ccd1d4f135aa9e5e8e5410aa05f98.png";